/**
 * Created by vallefor on 02.03.18.
 */
import merge from 'lodash/merge';

export default function wsClient(opts={})
{
	var self=this;
	self.ws=false;
	self.manual_close=false;

	self.func={};

	self.opts={
		onError:function(evt){},
		onMessage:function(evt){},
		onClose:function(evt){},
		onOpen:function(evt){}
	};

	self.opts=merge(self.opts,opts);

	self.connected=false;

	//self.opts=$.extend(self.opts,opts);

	self.disconnect=function() {
		self.manual_close=true;
		self.ws.close();
	};
	self.connect=function() {
		self.ws=new WebSocket(self.opts.url);
		self.ws.onopen=function(e) {
			self.manual_close=false;
			self.connected=true;
			self.opts.onOpen(e);
		};

		self.ws.onmessage=function(e) {
			self.opts.onMessage(e);
			var data=JSON.parse(e.data);
			if(typeof data != "undefined") {
				self.executeOnMessage(data.channel, data);
			}
		};

		self.ws.onclose=function(e) {
			self.connected=false;
			self.opts.onClose(e);
			if(!self.manual_close) {
				setTimeout(function () {
					self.connect();
				}, 1000);
			}
		};

		self.ws.onerror=function(e) {
			self.opts.onError(e);
		};
	};

	self.send=function(json){
		self.ws.send(JSON.stringify(json));
	};

	self.auth=function(cookieLogin,cookiePass)
	{
		if(self.ws){
			self.send({
				command:"auth_cookie",
				login:cookieLogin,
				pass:cookiePass
			});
		}
	};

	self.executeOnMessage=function(channel,message)
	{
		if(typeof self.func[channel] != "undefined"){
			for(var i in self.func[channel]) {
				self.func[channel][i](message);
			}
		}
	};

	self.pushOnMessage=function(channel,func) {
		if(typeof self.func[channel] == "undefined"){
			self.func[channel]=[];
		}
		self.func[channel].push(func);
		return self.func[channel].length-1;
	};

	self.removeOnMessage=function(channel,ind){
		delete self.func[channel][ind];
	};

	setInterval(function(){
		self.send({ command:"ping" });
	},1000*60*5)

};